import { experiments } from '../experiments';
import { renderModel } from './renderModel';

const isStudioEditor = renderModel.isStudioEditor();

export const useIsNewHomePage = () =>
  !isStudioEditor && experiments.is('specs.helpwidget.newHomePage', 'true');
